export const SET_TASKS = "OPS_DASHBOARD_SET_TASKS";
export const APPEND_TASKS = "OPS_DASHBOARD_APPEND_TASKS";
export const SET_TOTAL = "OPS_DASHBOARD_SET_TOTAL";
export const SET_STATS = "OPS_DASHBOARD_SET_STATS";
export const SET_LOADING = "OPS_DASHBOARD_SET_LOADING";
export const SET_LOADING_MORE = "OPS_DASHBOARD_SET_LOADING_MORE";
export const SET_FILTERS = "OPS_DASHBOARD_SET_FILTERS";
export const SET_SELECTED_TASK_ID = "OPS_DASHBOARD_SET_SELECTED_TASK_ID";
export const TOGGLE_HIDE_COMPLETED = "OPS_DASHBOARD_TOGGLE_HIDE_COMPLETED";
export const SET_COMPLETED_TASKS = "OPS_DASHBOARD_SET_COMPLETED_TASKS";
export const APPEND_COMPLETED_TASKS = "OPS_DASHBOARD_APPEND_COMPLETED_TASKS";
export const SET_COMPLETED_TOTAL = "OPS_DASHBOARD_SET_COMPLETED_TOTAL";
export const SET_LOADING_MORE_COMPLETED =
  "OPS_DASHBOARD_SET_LOADING_MORE_COMPLETED";
